import { create } from 'zustand';
import { IUser } from '../../../../interfaces/entities';

interface MailState {
  selectedUser?: IUser;
  setSelectedUser: (user: IUser) => void;
  update: boolean;
  forceUpdate: () => void;
}

const useMailStore = create<MailState>((set) => ({
  setSelectedUser: (user) => set(() => ({ selectedUser: user })),
  update: false,
  forceUpdate: () => set((state) => ({ update: !state.update }))
}));

export { useMailStore };
